var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 4H50V38H0V4ZM19.0243 31C18.9583 30.6331 18.922 30.2556 18.922 29.8691C18.922 26.4372 21.6432 23.6551 25 23.6551C28.3568 23.6551 31.078 26.4372 31.078 29.8691C31.078 30.2555 31.0417 30.6331 30.9757 31H41.5V27.7722H38.4272C38.091 25.5032 37.2172 23.415 35.9436 21.6462L38.1175 19.4236L35.2169 16.4581L33.0429 18.6807C31.3129 17.3786 29.2703 16.4853 27.0509 16.1416V13H22.9489V16.1416C20.7296 16.4853 18.687 17.3786 16.9569 18.6807L14.783 16.4581L11.8825 19.4236L14.0564 21.6462C12.7828 23.415 11.909 25.5032 11.5728 27.7722H8.5V31H19.0243Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19 40H31V44H35.0391C35.5913 44 36.0391 44.4477 36.0391 45C36.0391 45.5523 35.5913 46 35.0391 46H15.313C14.7607 46 14.313 45.5523 14.313 45C14.313 44.4477 14.7607 44 15.313 44H19V40Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    fillRule: "evenodd",
    d: "M0 30H50V38H0V30Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.e3888a3657d7c766bd9339edd8ad5bec.svg";
export { ForwardRef as ReactComponent };